import * as types from "./action-types";
import { LEFT_NAV_COLLAPSED, SET_LEFT_NAV_COLLAPSED } from "./action-types";

const actions = {};

const state = {
  locale: "en",
  isLoading: false,
  currentTimezone: "UTC",
  labelTimeZone: "UTC",
};

const getters = {
  locale: (state) => state.locale,
  isLoading: (state) => state.isLoading,
  currentTimezone: (state) => state.currentTimezone,
  labelTimeZone: (state) => state.labelTimeZone,
  isLeftNavCollapsed: (state) => state.isLeftNavCollapsed,
};

const mutations = {
  [types.SET_LOADING](state, data) {
    state.isLoading = data;
  },
  [types.SET_UI_USER_TIMEZONE](state, timezone) {
    state.currentTimezone = timezone.tz;
    localStorage.setItem("locationTZ", timezone.label);
  },
  [types.SET_LOCALE](state, data) {
    state.locale = data;
  },
  resetState(state) {
    if (localStorage.getItem("locationTZ") != "Local Timezone") {
      console.log("CleanupLocalTZ");
      localStorage.removeItem("locationTZ");
    }
  },
  [types.SET_LEFT_NAV_COLLAPSED](state, isCollapsed) {
    state.isLeftNavCollapsed = isCollapsed;
  },
};
// Add non asynchronous actions
Object.assign(actions, {
  setLoading({ commit }, data) {
    commit(types.SET_LOADING, data);
  },
  async setUserTimezone({ commit }, { current }) {
    commit(types.SET_UI_USER_TIMEZONE, current);

    return current;
  },
  async setLocale({ commit }, data) {
    commit(types.SET_LOCALE, data);
    return data;
  },
  setIsLeftNavCollapsed({ commit }, isCollapsed) {
    commit(types.SET_LEFT_NAV_COLLAPSED, isCollapsed);
  },
});

export default { state, mutations, actions, getters, namespaced: true };
